import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components";

const PageNotFound = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-12 py-5 text-center rounded-3" style={{ backgroundColor: 'var(--surface-color)', border: 'var(--glass-border)' }}>
              <h4 className="p-3 display-5">404: Page Not Found</h4>
              <Link to="/" className="btn btn-outline-light mx-4">
                <i className="fa fa-arrow-left"></i> Go Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
